var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Switcher } from "../../ReactReduxForms";
import { Translate } from "../../I18N";

import { NeedAuthorization } from "../../Auth";
import { withRouter } from "../../componentWrappers";

import { filterDocumentTypes } from "../actions/filterActions";
import DocumentTypesList from "./DocumentTypesList";











const mapStateToProps = (state) => ({
  collection: state.settings.collection,
  libraryFilters: state.library.filters
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ filterDocumentTypes }, dispatch);
}

const connector = connect(mapStateToProps, mapDispatchToProps);



const filterValidSelectedTemplates = (configuredFilters, selectedTemplates) =>
configuredFilters.length ?
selectedTemplates.filter((t) => configuredFilters.includes(t)) :
selectedTemplates;

const flattenConfiguredFilters = (configuredFilters) =>
configuredFilters.reduce((result, filter) => {
  if (filter.items && filter.items.length) {
    const items = filter.items.map((item) => item.id);
    result.push(...items);
  }
  result.push(filter.id);
  return result;
}, []);

class TemplatesFilterComponent extends React.Component {
  constructor(props) {
    super(props);
    const configuredFilters = flattenConfiguredFilters(
      props.collection.toJS().filters || []
    );
    const currentSelection = props.libraryFilters.toJS().documentTypes || [];
    const newSelection = filterValidSelectedTemplates(configuredFilters, currentSelection);
    const documentTypeFromFilters = _.isEqual(currentSelection, newSelection);

    this.state = {
      documentTypeFromFilters,
      selectedTemplates: newSelection,
      configuredFilters
    };
  }

  static getDerivedStateFromProps(props, state) {
    const currentSelection = props.libraryFilters.toJS().documentTypes || [];
    const newSelection = state.documentTypeFromFilters ?
    filterValidSelectedTemplates(state.configuredFilters, currentSelection) :
    currentSelection;
    return { selectedTemplates: newSelection };
  }

  toggleTemplateFilter(
  checked,
  configuredFilters,
  selectedTemplates)
  {
    if (checked) {
      const newSelectedItems = filterValidSelectedTemplates(configuredFilters, selectedTemplates);
      this.setState({ selectedTemplates: newSelectedItems });
      this.props.filterDocumentTypes(newSelectedItems, this.props.location, this.props.navigate);
    }
    this.setState({ documentTypeFromFilters: checked });
  }

  render() {
    return /*#__PURE__*/(
      _jsx("div", { className: "form-group" }, void 0, /*#__PURE__*/
      _jsx("ul", { className: "search__filter" }, void 0,
      this.state.configuredFilters.length > 0 && /*#__PURE__*/
      _jsx(NeedAuthorization, { roles: ['admin', 'editor', 'collaborator'] }, void 0, /*#__PURE__*/
      _jsx("li", {}, void 0, "\xA0", /*#__PURE__*/

      _jsx(Switcher, {
        className: "template-filter-switcher",
        model: "",
        value: this.state.documentTypeFromFilters,
        onChange: (checked) =>
        this.toggleTemplateFilter(
          checked,
          this.state.configuredFilters,
          this.state.selectedTemplates
        ),

        leftLabel: /*#__PURE__*/_jsx(Translate, {}, void 0, "FEATURED"),
        rightLabel: /*#__PURE__*/_jsx(Translate, {}, void 0, "ALL") }
      )
      )
      ), /*#__PURE__*/

      _jsx("li", { className: "wide documentTypes-selector" }, void 0, /*#__PURE__*/
      _jsx(DocumentTypesList, {
        fromFilters:
        this.state.documentTypeFromFilters && this.state.configuredFilters.length > 0,

        selectedTemplates: this.state.selectedTemplates }
      )
      )
      )
      ));

  }
}

export const ConnectedComponent = connector(TemplatesFilterComponent);

export const TemplatesFilter = connector(withRouter(TemplatesFilterComponent));